import { FC, useEffect, useState } from 'react'

import { Tab } from 'components'

import {
  Contract,
  Effective,
  Consolidation,
  CockpitParameters,
  Block,
  Archives,
  TalkWithUs,
  CreParams,
  RollDocuments,
  Jobs,
  GroupEmail,
  EfetivoLogico
} from './components'
import { paths } from 'navigation/routes'
import { PERMITIONS } from 'components/DrawerMenu/routes_list'
import { useAuth } from 'hooks'

const Parameterization: FC = () => {
  const { user: { PerfilUsuarioId } } = useAuth();
  const [tabs, setTabs] = useState<string[]>([]);



  const isSegLog = () => {
    return PerfilUsuarioId === PERMITIONS.CSNSEGURANCALOGICA ?? false;
  }

  useEffect(() => {
    if (isSegLog())
      setTabs(['Efetivo Lógico'])
    else
      setTabs([
        'Contratos',
        'Efetivos',
        'Consolidação',
        'CRE',
        'Bloqueio',
        'Jobs',
        'Fale Conosco',
        'Arquivos',
        'Rol de Documentos',
        'Grupo E-mails',
        'Cockpit',
      ])

  }, [])

  const [selectedTab, setSelectedTab] = useState<number>(0)

  const handleChange = (_, newValue) => setSelectedTab(newValue)
  return (
    isSegLog() ? (selectedTab === 0 &&
      (<>
        <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
        <EfetivoLogico />
      </>)) :
      (<>
        <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
        {selectedTab === 0 && <Contract />}
        {selectedTab === 1 && <Effective />}
        {selectedTab === 2 && <Consolidation />}
        {selectedTab === 3 && <CreParams />}
        {selectedTab === 4 && <Block />}
        {selectedTab === 5 && <Jobs />}
        {selectedTab === 6 && <TalkWithUs />}
        {selectedTab === 7 && <Archives />}
        {selectedTab === 8 && <RollDocuments />}
        {selectedTab === 9 && <GroupEmail />}
        {selectedTab === 10 && <CockpitParameters />}
      </>)
  )
}

export default Parameterization
